"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarPlaceholder = void 0;
var React = require("react");
var _Core_1 = require("../../_Core");
var Icons_1 = require("../../Icons");
var AvatarPlaceholder_styles_1 = require("./AvatarPlaceholder.styles");
var AvatarPlaceholder = function (species, Initials) {
    if (Initials) {
        return Initials;
    }
    else {
        if (species === "Human") {
            return function (_a) {
                var Size = _a.Size;
                return React.createElement(AvatarPlaceholder_styles_1.UserWrapper, null,
                    React.createElement(Icons_1.UserIcon, { Height: Size + "px", Width: Size + "px" }));
            };
        }
        else {
            return _Core_1.Icons.Paw;
        }
    }
};
exports.AvatarPlaceholder = AvatarPlaceholder;
